﻿//components
import Answer from '../Form/Answer'
import Link from './Link'

const QuestionHeader = ({
    id,
    paragraph2,
    paragraph3,
    index,
    total,
    headline,
    text,
    answer,
    showCount,
    count,
    showApplication
}) => {

    const downloadQuestion = '5919a64a-884d-4a5c-80f3-f3d63e68b2f5'

    return (
        <div className="pension-wizard-block__question__card__question">

            {showCount && total &&
                <legend className="pension-wizard-block__question__card__count">{`${count ? count : index + 1}`} av {total}</legend>
            }
         
            <h3 className="pension-wizard-block__question__card__headline">{headline}</h3>
            <p className="pension-wizard-block__question__card__info">{text}</p>

            {paragraph2 && <p className="pension-wizard-block__question__card__info">{paragraph2}</p>}
            {paragraph3 && <p className="pension-wizard-block__question__card__info">{paragraph3}</p>}

            {id === downloadQuestion &&
                <Link
                    href={"/pensionsforsakringsdokument/futur-produktinformation"}
                    linkText="Förköpsinformation, faktablad och villkor" />
            }

            {showApplication && <Link
                href={`/pensionsforsakringsdokument/ansokan/${id}`}
                linkText="Ansökan om sparande" />
            }

            {answer && answer !== '' &&
                <Answer
                    answer={answer}
                    index={index + 1}
                    total={total}
                    showCount={showCount}
                />
            }
        </div>
      )
}

export default QuestionHeader;

